import { StyleSheet } from '@react-pdf/renderer';

export const sharedStyles = StyleSheet.create({
  fullWidth: {
    width: '100%',
  },
  fullHeight: {
    height: '100%',
  },
  horizontalCenter: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  verticalCenter: {
    flexDirection: 'column',
    justifyContent: 'center',
  },
});
